import { render, staticRenderFns } from "./CompetitionResult.vue?vue&type=template&id=ff6064b0&scoped=true&"
import script from "./CompetitionResult.vue?vue&type=script&lang=js&"
export * from "./CompetitionResult.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionResult.vue?vue&type=style&index=0&id=ff6064b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6064b0",
  null
  
)

export default component.exports